<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_TASK_MNRT_RQS_INFO") }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_TYPE_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.taskMonitoringTypeName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              name="button"
              class="btn_innerTbl_border"
              @click="onPopupTaskMonitoringType"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.moduleName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.subModuleName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model.trim="taskMonitoringTypeData.taskMonitoringTypeContent"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_PRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.taskMonitoringCycleTypeName"
              placeholder
              :disabled="false"
              :readonly="true"
            />

            <div
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode == 'W'"
              class="comp_spacing"
            />
            <sui-text-field
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode == 'W'"
              v-model.trim="taskMonitoringTypeData.taskMonitoringStandardDayOfTheWeekCode"
              placeholder
              :disabled="false"
              :readonly="true"
            />

            <div
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode == 'M'"
              class="comp_spacing"
            />
            <sui-text-field
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode == 'M'"
              v-model.trim="taskMonitoringTypeData.taskMonitoringStandardDay"
              placeholder
              :disabled="false"
              :readonly="true"
            />

            <div class="comp_spacing" />
            <sui-time-picker
              v-model.trim="timePickerValue"
              format="HH:mm"
              :disabled="true"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RSULT_SEND_MD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.taskMonitoringSendMediaName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.taskMonitoringExtractionStandardValue"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_TASK_MNRT_RQS_INFO") }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_START_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-date-picker
              ref="dpTaskMonitoringStartDate"
              v-model="taskMonitoringRequestData.taskMonitoringStartDate"
              :disabled-dates="disabledDatesTo"
            />
          </div>
          <div class="col-xs-1"/>
          <div class="col-xs-5"/>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_STNDR_START_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-date-picker
              ref="dpStartDate"
              v-model="convertExtractionStandardValue.startDate"
              :disabled="false"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_STNDR_END_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-date-picker
              ref="dpEndDate"
              v-model="convertExtractionStandardValue.endDate"
              :disabled="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_STNDR_SITE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="convertExtractionStandardValue.siteName"
              placeholder
              :disabled="false"
              :readonly="false"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              name="button"
              class="btn_innerTbl_border"
              @click="onPopupSite"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
        <div
          v-for="item in extractionStandardValues"
          :key="item.key"
          class="row"
        >
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ item.label }}
            </div>
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="item.key"
              placeholder
              :disabled="false"
              :readonly="false"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClose"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMS_00015_P01', // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00015',
    },
  },
  data() {
    return {
      extractionStandardValues: [],

      timePickerValue: {
        HH: '00',
        mm: '00',
      },

      // 업무 모니터링 유형 데이터
      taskMonitoringTypeData: {
        taskMonitoringTypeUID: '',
        taskMonitoringTypeName: '',
        moduleCode: '',
        moduleName: '',
        subModuleCode: '',
        subModuleName: '',
        taskMonitoringCycleTypeCode: '',
        taskMonitoringCycleTypeName: '',
        taskMonitoringStandardDayOfTheWeekCode: '',
        taskMonitoringStandardDayOfTheWeekName: '',
        taskMonitoringStandardDay: '',
        taskMonitoringStandardTime: '',
        taskMonitoringSendMediaCode: '',
        taskMonitoringSendMediaName: '',

        taskMonitoringExtractionStandardValue: '',

        taskMonitoringTypeContent: '',
      },

      disabledDatesTo: { from: null, to: new Date() },

      // 업무 모니터링 요청 데이터
      taskMonitoringRequestData: {
        taskMonitoringTypeUID: '',
        taskMonitoringRequestUID: '',
        taskMonitoringHistoryUID: '',
        taskMonitoringStartDate: new Date(),
        taskMonitoringRequestStandardValue: '',
      },

      convertExtractionStandardValue: {
        startDate: new Date(),
        endDate: new Date(),
        siteId: '',
        siteName: '',
      },
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onPopupTaskMonitoringType() {
      utils.openLayerPopup('PGE_CMS_00014', this.onPagePopupCloseTaskMonitoringType, {
        pageInitialData: {},
        size: 'lg',
      });
    },
    onPagePopupCloseTaskMonitoringType(nodeData) {
      if (nodeData) {
        this.searchTaskMonitoringType(nodeData[0].taskMonitoringTypeUID);
      }
    },
    onPopupSite() {
      utils.openLayerPopup('PGE_CMY_00016', this.onPagePopupCloseSite, {
        pageInitialData: {},
        size: 'lg',
      });
    },
    onPagePopupCloseSite(objSite) {
      // if(objSite != null && utils.isEmpty(objSite) == false && objSite.length > 0) {
      if (objSite) {
        this.convertExtractionStandardValue.siteId = objSite[0].siteId;
        this.convertExtractionStandardValue.siteName = objSite[0].siteAbbreviationName;
      }
    },
    onClose() {
      this.$emit('close');
    },
    onSave() {
      // date picker validation
      if (this.onClickValidate()) return false;
      this.save();

      return null;
    },
    /** ***************************************************************************
        함수 영역
      ***************************************************************************** */
    // 유형 관련 정보
    searchTaskMonitoringType(sTaskMonitoringTypeUID) {
      http.request(this.pageId, 'DTS_CMS_00033', {
        path: {
          'task-monitoring-type-id': utils.trim(sTaskMonitoringTypeUID),
        },
      }).then(res => {
        const has = Object.prototype.hasOwnProperty;
        utils.forEach(res.data, (value, key) => {
          if (utils.has(this.taskMonitoringTypeData, key)) {
            if ((this.taskMonitoringTypeData[key] !== null && this.taskMonitoringTypeData[key] !== ''
            && this.taskMonitoringTypeData[key] !== undefined) && has.call(this.taskMonitoringTypeData[key], 'key')) {
              utils.set(this.taskMonitoringTypeData, key, { key: value, label: '' });
            } else {
              utils.set(this.taskMonitoringTypeData, key, value);
            }
          }
        });

        const sStandarDate = `${this.taskMonitoringTypeData.taskMonitoringStandardTime}`;
        this.timePickerValue = { HH: sStandarDate.substr(0, 2), mm: sStandarDate.substr(2, 2) };


        this.initTaskMonitoringRequestForm();
      }).catch(error => {
        console.log(error);
      });
    },

    // 요청 관련 정보
    initTaskMonitoringRequestForm() {
      // 요청 UID 세팅
      this.taskMonitoringRequestData.taskMonitoringTypeUID = this.taskMonitoringTypeData.taskMonitoringTypeUID;

      // 기준 정보 폼 세팅
      this.extractionStandardValues = [];
      // AAA,BBB,CCC
      if (utils.isEmpty(this.taskMonitoringTypeData.taskMonitoringExtractionStandardValue) === false) {
        const tempArray = this.taskMonitoringTypeData.taskMonitoringExtractionStandardValue.split(',');
        utils.forEach(tempArray, standardValue => {
          this.extractionStandardValues.push({ key: '', label: standardValue });
        });
      }
    },
    setRequestExtractionStandardValue() {
      // datePicker 변환
      this.convertExtractionStandardValue.startDate = utils.toStringByFormat(
        this.convertExtractionStandardValue.startDate, 'YYYYMMDD',
      );
      this.convertExtractionStandardValue.endDate = utils.toStringByFormat(
        this.convertExtractionStandardValue.endDate, 'YYYYMMDD',
      );

      let extractionStandardValue = `startDate=${this.convertExtractionStandardValue.startDate}`;
      extractionStandardValue += `,endDate=${this.convertExtractionStandardValue.endDate}`;
      extractionStandardValue += `,siteId=${this.convertExtractionStandardValue.siteId}`;
      extractionStandardValue += `,siteName=${this.convertExtractionStandardValue.siteName}`;

      utils.forEach(this.extractionStandardValues, item => {
        extractionStandardValue += `,${item.label}=${item.key}`;
      });

      this.taskMonitoringRequestData.taskMonitoringRequestStandardValue = utils.trim(extractionStandardValue);
    },
    save() {
      // 기준값 Converting
      this.setRequestExtractionStandardValue();

      // datePicker 변환
      this.taskMonitoringRequestData.taskMonitoringStartDate = utils.toStringByFormat(
        this.taskMonitoringRequestData.taskMonitoringStartDate, 'YYYYMMDD',
      );

      // formData -> paramsObj변환 { key : value, key : value }
      const dataParams = utils.reduce(this.taskMonitoringRequestData, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      // form validation(dataParams)
      if (!this.formValidate(dataParams)) {
        return false;
      }

      // save
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00039', {
          data: dataParams,
        }).then(res => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('save');
          console.log(res);
        }).catch(error => {
          console.log(error);
        });
      });      

      return true;
    },
    // formData{ key : value, key : value, ... }
    formValidate(formData) {
      let isVaildate = true;

      const objMsgList = {
        taskMonitoringTypeUID: this.$t('MSG_TXT_TASK_MNTR_TYPE_NM'),
        taskMonitoringStartDate: this.$t('MSG_TXT_RQS_START_DT'),
        taskMonitoringRequestStandardValue: this.$t('MSG_TXT_EXTC_STNRD'),
      };
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(objMsgList, (value, key) => {
        if (has.call(formData, key)) {
          if (utils.isEmpty(utils.trim(formData[key]))) {
            utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), objMsgList[key]));
            isVaildate = false;

            // TODO break;
            return false;
          }
        }
        return true;
      });

      return isVaildate;
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.dpEndDate.isValid()
        || !this.$refs.dpStartDate.isValid()
        || !this.$refs.dpTaskMonitoringStartDate.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
